// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import CompetenceProfileLayout from './CompetenceProfileLayout';

import CompetenceService from '../../services/CompetenceService';

const DeleteCompetence = () => {
	const [competence, setCompetence] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([CompetenceService.getCompetence(id)]).then(
			([competenceData]) => {
				setCompetence(competenceData.data);
			}
		);
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the CompetenceService to delete the competence
			await CompetenceService.deleteCompetence(id);

			// Redirect the user to the list of competences
			navigate('/pedagogie/competences');
		} catch (error) {
			console.error('Erreur lors de la suppression de la compétence', error);
		}
	};

	return (
		<CompetenceProfileLayout>
			{competence && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer la compétence{' '}
										<span className="text-uppercase">
											{competence.nom || ''}
										</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement cette compétence.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez cette compétence, toutes les données et
									informations associées seront définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer la compétence
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</CompetenceProfileLayout>
	);
};

export default DeleteCompetence;
